import { PropsWithChildren } from "react";
import styles from "./ImageSelector.module.css";

export const ImageSelectorContainer = (props: PropsWithChildren<{}>) => {
    return <ul className={styles.ImageSelectorContainer}>{props.children}</ul>;
};
